import React__default, { useMemo } from 'react';
import { D as DATE_FORMAT } from '../../defaults-1329a7d1.js';
import { u as useCombinedRefs } from '../../useCombinedRefs-56aeb9e7.js';
import { u as useId } from '../../useId-f4885202.js';
import { D as DateInputContainer } from '../../index-0f115bc2.js';
import { D as DatePicker } from '../../index-6ce3b4a6.js';
import { u as useResolvedDateValue } from '../../utils-40bbab3c.js';
import '../../index-23844e78.js';
import '../../index-8887fc24.js';
import '../../tslib.es6-18cb2814.js';
import '../../ChevronRightIcon-b72559d2.js';
import '../../countries-34fea817.js';
import '../../index-b7114926.js';
import 'react-router-dom';
import '../../skeleton.module-7c98b8f8.js';
import '../../ThemeProvider-e3ab770b.js';
import '../../DatePickerDropdownContext-0827e650.js';
import '../../ArrowDownIcon-fbdb97a6.js';
import '../../index-21f083b4.js';
import '../../index-aa64515a.js';
import '../../index-b7606a36.js';
import 'react-spring';
import 'react/jsx-runtime';
import 'react-dom';
import '../../useOrchard-45cfc194.js';
import './IconButton.js';
import './TextLink.js';
import './Typography.js';
import '../../ResizeObserver-d78e3707.js';
import '../../CircleAlertIcon-a6cd83ad.js';
import '../../CloseIcon-25692563.js';
import '../../InfoIcon-22134611.js';
import './TextInput.js';
import '../../TextInput.module-7e116b65.js';
import '../../index-b6dc1a1e.js';

var DateInput = React__default.forwardRef(function DateInput(props, ref) {
    var className = props.className, value = props.value, labelClassName = props.labelClassName, label = props.label, showLabel = props.showLabel, startDate = props.startDate, boundingRange = props.boundingRange, highlightToday = props.highlightToday, onValueChangeProp = props.onValueChange, hideMonthPicker = props.hideMonthPicker, hideYearPicker = props.hideYearPicker, _a = props.dateFormat, dateFormat = _a === void 0 ? DATE_FORMAT : _a, hideDaysOutsideMonth = props.hideDaysOutsideMonth, minimizeWeeks = props.minimizeWeeks, disabled = props.disabled, variant = props.variant, idProp = props.id, dataTestId = props["data-testid"], placeholder = props.placeholder;
    var innerRef = React__default.useRef(null);
    var textInputRef = useCombinedRefs(ref, innerRef);
    var generatedId = useId();
    var id = useMemo(function () { return idProp !== null && idProp !== void 0 ? idProp : generatedId; }, [idProp, generatedId]);
    var _b = useResolvedDateValue(value, onValueChangeProp, dateFormat), resolvedValue = _b.resolvedValue, onValueChange = _b.onValueChange, getFormattedValue = _b.getFormattedValue;
    return (React__default.createElement(DateInputContainer, { labelClassName: labelClassName, label: label, showLabel: showLabel, popoverTestId: "dateinput-popover", className: className, formattedValue: getFormattedValue() || "", ref: textInputRef, disabled: disabled, variant: variant, id: id, "data-testid": dataTestId, placeholder: placeholder }, function (_a) {
        var open = _a.open, setOpen = _a.setOpen;
        return (React__default.createElement(DatePicker, { value: resolvedValue, startDate: startDate, boundingRange: boundingRange, highlightToday: highlightToday, onValueChange: function (val) {
                onValueChange(val);
                setOpen(false);
            }, hideMonthPicker: !open || hideMonthPicker, hideYearPicker: !open || hideYearPicker, hideDaysOutsideMonth: hideDaysOutsideMonth, minimizeWeeks: minimizeWeeks }));
    }));
});

export { DateInput };
